import classNames from 'classnames';

import styles from '../../styles/blocks/table-block.module.css';

interface TableCell {
    heading?: boolean;
    align?: 'left' | 'center' | 'right' | null;
    colspan?: number;
    body?: string;
}

interface TableRow {
    section?: 'header' | 'body' | 'footer' | null;
    cells: TableCell[];
}

interface TableSection {
    tag: 'thead' | 'tbody' | 'tfoot';
    rows: TableRow[];
}

interface TableBlockProps {
    rows?: TableRow[] | null;
    className?: string | null;
}

function TableBlock({ rows = null, className = null }: TableBlockProps) {
    const finalRows = rows || [];
    const sections = [
        {
            tag: 'thead',
            rows: finalRows.filter(({ section }) => section === 'header'),
        } as TableSection,
        {
            tag: 'tbody',
            rows: finalRows.filter(({ section = null }) => section === 'body' || section === null),
        } as TableSection,
        {
            tag: 'tfoot',
            rows: finalRows.filter(({ section }) => section === 'footer'),
        } as TableSection,
    ].filter(({ rows: sectionRows }) => sectionRows.length > 0);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <table width="100%" cellPadding="0" cellSpacing="0" className={styles.table}>
                {sections.map(({ tag: SectionComponent, rows: sectionRows }) => (
                    <SectionComponent key={`section-${SectionComponent}`}>
                        {sectionRows.map(({ cells }) => {
                            const rowKey = `${SectionComponent}-${cells
                                .map(({ body = '' }) => body)
                                .join('|')}`;
                            return (
                                <tr key={rowKey}>
                                    {cells.map(
                                        ({ heading, align, colspan, body: cellBody = '' }) => {
                                            const CellComponent = heading ? 'th' : 'td';
                                            const cellKey = `${rowKey}-${heading ? 'h' : 'd'}-${align || ''}-${colspan || ''}-${cellBody}`;
                                            return (
                                                <CellComponent
                                                    key={cellKey}
                                                    align={align || undefined}
                                                    colSpan={colspan}
                                                    dangerouslySetInnerHTML={{ __html: cellBody }}
                                                />
                                            );
                                        },
                                    )}
                                </tr>
                            );
                        })}
                    </SectionComponent>
                ))}
            </table>
        </div>
    );
}

export default TableBlock;
